import { createActionGroup, emptyProps, props } from "@ngrx/store";
import { INotification } from "src/app/core/models/notification";
import { SchoolNotificationSettings, StudentNotificationSettings } from "../../models/messaging";

// Create an action group for Notification-related actions
export const NotificationActions = createActionGroup({
    source: 'Notification',
    events: {
        'Add Notification': props<{ notification: INotification }>(),
        'Mark As Read': props<{ id: string }>(),
        'Delete Notification': props<{ id: string }>(),

        // Load notifications actions
        'Load Notifications': emptyProps(),
        'Load Notifications Success': props<{ notifications: INotification[] }>(),
        'Load Notifications Failure': props<{ error: string }>(),

        'Dismiss All': emptyProps(),
        'Read All': emptyProps(),

        //Student Settings
        'Initialise Student Settings': props<{ students: { id: string }[] }>(),
        'Update Student Settings': props<{ studentId: string, settings: Partial<StudentNotificationSettings> }>(),

        //School Settings
        'Initialise School Settings': props<{ schools: { id: string }[] }>(),
        'Update School Settings': props<{ schoolId: string, settings: Partial<SchoolNotificationSettings> }>()
    }
});